import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "ceco-polyglot";
import { Header } from "../../components/cecoadmin-panel";
import FullWidthLayout from "../../layout/FullWidthLayout";
import { FiltersTable } from "../../components/tables/FiltersTable";
import CreateButton from "../../components/CreateButton";
import { Dimmer, Loader } from "semantic-ui-react";
import TogglerHeader from "../../components/TogglerHeader";
import graphql from "babel-plugin-relay/macro";
import { createPaginationContainer } from "react-relay";

const FiltersPage = (props) => {
  const {
    sidebarExpanded,
    setSidebarExpanded,
    setSidebarProps,
    menuExpanded,
    setMenuExpanded,
    allCategories,
    allLabelGroup,
    relay,
    children,
    ...rest
  } = props;
  const [search, setSearch] = useState();
  const { totalCount, edges } = allLabelGroup.allLabelGroup;
  const [isLoading, setIsLoading] = useState(false);
  const [orderBy, setOrderBy] = useState("ascendent");
  const loadSearch = useRef(false);
  const t = useTranslation();

  const labelParsed = edges.map((label, i) => {
    return {
      ...label.node,
    };
  });

  useEffect(() => {
    document.title = `Recetario Mambo - ${t("title.filters")}`;
  }, [t]);

  const _loadMore = () => {
    if (!relay.hasMore() || relay.isLoading()) {
      return;
    }
    setIsLoading(true);
    relay.loadMore(20, (t) => {
      setIsLoading(false);
    });
  };

  const _refetch = () => {
    setIsLoading(true);

    relay.refetchConnection(
      search === "" || search === undefined ? 20 : null,
      () => setIsLoading(false),
      {
        name: search === "" || search === undefined ? null : search,
        orderBy: orderBy,
      }
    );
  };

  const handleScroll = (e) => {
    const target = e.target;
    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      _loadMore();
    }
  };

  const onSearchText = useCallback(
    (txt) => {
      setSearch(txt);
    },
    [setSearch]
  );

  useEffect(() => {
    if (loadSearch.current) {
      setIsLoading(true);

      relay.refetchConnection(
        search === "" || search === undefined ? 20 : null,
        () => setIsLoading(false),
        {
          name: search === "" || search === undefined ? null : search,
          orderBy: orderBy,
        }
      );
    }
    loadSearch.current = true;
  }, [relay, search, orderBy]);

  return (
    <FullWidthLayout>
      <Header
        title={t("title.filters")}
        menuExpanded={menuExpanded}
        setMenuExpanded={setMenuExpanded}
        onSearchTextChange={onSearchText}
      >
        <CreateButton allCategories={allCategories} refetchData={_refetch} />
      </Header>

      <TogglerHeader
        setOrderBy={setOrderBy}
        hasCardMode={false}
        newOptions={[
          {
            key: "ascendent",
            text: t("filter.ascendent"),
            value: "name",
          },
          {
            key: "descendent",
            text: t("filter.descendent"),
            value: "-name",
          },
        ]}
      />

      <div className="table-wrapper">
        <>
          <FiltersTable
            labelParsed={labelParsed}
            totalCount={totalCount}
            _refetch={_refetch}
            handleScroll={handleScroll}
            {...rest}
          />
          {isLoading && (
            <Dimmer inverted active>
              <Loader indeterminate />
            </Dimmer>
          )}
        </>
      </div>
    </FullWidthLayout>
  );
};

export default createPaginationContainer(
  FiltersPage,
  {
    allLabelGroup: graphql`
      fragment FiltersPage_allLabelGroup on Query
      @argumentDefinitions(
        name: { type: "String" }
        orderBy: { type: "String", defaultValue: "name" }
        count: { type: "Int", defaultValue: 20 }
        cursor: { type: "String" }
      ) {
        allLabelGroup(
          name: $name
          orderBy: $orderBy
          first: $count
          after: $cursor
        ) @connection(key: "Filters_allLabelGroup") {
          totalCount
          edges {
            node {
              id
              name
              labels {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    `,
  },
  {
    direction: "forward",
    getConnectionFromProps(props) {
      return props.allLabelGroup && props.allLabelGroup.allLabelGroup;
    },

    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        count,
        cursor,
        orderBy: fragmentVariables.orderBy,
      };
    },
    query: graphql`
      query FiltersPagePaginationQuery(
        $name: String
        $orderBy: String
        $count: Int
        $cursor: String
      ) {
        ...FiltersPage_allLabelGroup
          @arguments(
            name: $name
            orderBy: $orderBy
            count: $count
            cursor: $cursor
          )
      }
    `,
  }
);
